import React from "react";
import { Button, Modal, Tag } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Messages } from "../Common/ValidateMessages";

const { confirm } = Modal;

export interface AllocationUser {
  userId: string;
  sei: string;
  mei: string;
  facultyName?: string;
  departmentName?: string;
  majorName?: string;
  courceName?: string;
  scoringStatus?: string;
}
interface Props {
  value?: AllocationUser;
  isSel?: boolean;
  oldStatus?: string;
  onChange?: (value?: AllocationUser) => void;
  onSelect: () => void;
  onChangeAlert: () => void;
}

export const AllocationButton = ({
  value,
  isSel,
  oldStatus,
  onChange,
  onSelect,
  onChangeAlert,
}: Props) => {
  const [user, setUser] = React.useState<AllocationUser>();
  const [oldStatusStr, setOldStatusStr] = React.useState<string>();
  const [isSelected, setIsSelected] = React.useState<boolean>();

  React.useEffect(() => {
    //console.log(`${value}|${isSel}`);
    setUser(value);
    setIsSelected(isSel);
    setOldStatusStr(oldStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, isSel, oldStatus]);

  const onDataChange = (newValue?: AllocationUser) => {
    // console.log(newValue);
    // setRadioValue(newValue);
    onChange?.(newValue ? newValue : undefined);
  };

  // const onButtonSelected = () => {
  //   setIsSelected(true);
  //   onSelect();
  // };

  const onButtonClick = (e) => {
    e.preventDefault();
    onSelect();
  };

  const onClear = (e) => {
    e.preventDefault();
    onDataChange(undefined);
  };
  const onClearAndAlert = (e) => {
    e.preventDefault();
    onDataChange(undefined);
    onChangeAlert();
  };

  const checkStatus =
    oldStatusStr === undefined ? user?.scoringStatus : oldStatus;

  return user ? (
    checkStatus === "3" ? (
      <Tag className="allocation-disabled-tag">
        {user.sei} {user.mei}
      </Tag>
    ) : checkStatus === undefined ||
      checkStatus === null ||
      checkStatus === "0" ? (
      <Tag closable onClose={onClear}>
        {user.sei} {user.mei}
      </Tag>
    ) : (
      <Tag
        closable
        onClose={(closeEvent) => {
          closeEvent.preventDefault();
          confirm({
            title: Messages["CON-032"],
            icon: <ExclamationCircleOutlined />,
            onOk: () => onClearAndAlert(closeEvent),
            onCancel: () => {},
            okText: "はい",
            cancelText: "いいえ",
          });
        }}
      >
        <span style={{ color: "#3fb0ac" }}>
          {user.sei} {user.mei}
        </span>
      </Tag>
    )
  ) : (
    <Button
      style={{ width: "100px" }}
      type="dashed"
      danger={!isSelected}
      onClick={onButtonClick}
    >
      -
    </Button>
  );
};
